<template>
  <button
    v-tooltip="capitalize(i18n.t(isActive ? 'messages.closeDealDetailsPane' : 'messages.showTargetingDetails'))"
    data-testid="request-deal-details-button"
    class="btn btn-no-text btn-xxs btn-info-hollow"
    @click="emits('activeDealChanged')">
    <component
      :is="isActive ? IconHide : IconEye"
      class="icon" />
  </button>
</template>

<script setup lang="ts">
  import { capitalize } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { IconEye, IconHide } from '@/common/icons/monochrome';

  interface IProps {
    isActive: boolean;
  }

  const { isActive } = defineProps<IProps>();

  const emits = defineEmits(['activeDealChanged']);

  const i18n = useI18n();
</script>

<style scoped lang="scss">
  @use '@/styles/variables' as *;
</style>
